import React, { useRef, useState } from "react";
import { LuChevronRight } from "react-icons/lu";
import "./style.css";

export const AccessSelector = ({ head, title, icon, data = [], callback, loading = false, feedback = "", onRetry }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);
  const select = async (item) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    setError("");
    try {
      await callback(item);
    } catch {
      setError("No se ha podido seleccionar. Vuelve a intentarlo.");
    } finally {
      inFlight.current = false;
      setBusy(false);
    }
  };
  return (
    <section className="accessSelector" aria-busy={busy || loading}>
      <h1 className="loginTitle">{head}</h1>
      <p className="tpvAccessHint">{title}</p>
      <div className="tpvAccessChoices" role="group" aria-label={title}>
        {data.map((item, index) => (
          <button
            type="button"
            className="tpvAccessChoice"
            aria-label={item.fullname || item.name}
            key={item.PointOfSaleConfigurationId || item.userId || `${item.fullname || item.name}-${index}`}
            disabled={busy || loading}
            onClick={() => select(item)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                select(item);
              }
            }}
          >
            <span className="tpvAccessChoiceIcon" aria-hidden="true">
              {item.userId
                ? (item.fullname || "?")
                    .trim()
                    .split(/\s+/)
                    .slice(0, 2)
                    .map((part) => part[0])
                    .join("")
                : icon}
            </span>
            <span className="tpvAccessCardText">
              <strong>{item.fullname || item.name}</strong>
              <small>{item.userId ? "Accede con tu PIN de empleado" : item.description || "Puesto de venta"}</small>
            </span>
            <LuChevronRight aria-hidden="true" className="tpvAccessArrow" />
          </button>
        ))}
      </div>
      {(busy || loading) && (
        <p role="status" className="tpvAccessStatus">
          {loading ? "Cargando puestos…" : "Seleccionando…"}
        </p>
      )}
      {!busy && !loading && !data.length && !feedback && (
        <p className="tpvAccessHint">
          No hay opciones disponibles. Solicita al administrador que revise las asignaciones de este puesto.
        </p>
      )}
      {(error || feedback) && (
        <p role="alert" className="tpvAccessError">
          {error || feedback}
        </p>
      )}
      {feedback && onRetry && (
        <button type="button" className="tpvAccessSecondary" disabled={loading || busy} onClick={onRetry}>
          Volver a cargar puestos
        </button>
      )}
    </section>
  );
};
